import { styled } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
const Divider = styled("div")({
    display: "flex",
    alignItems: "center",
    gap: "var(--j-sp-2)",
    fontSize: "var(--j-fs-xs)",
    lineHeight: "var(--j-lh-xs)",
    color: "var(--j-ink-3)",
    textAlign: "center",
    "&::before, &::after": {
        content: '""',
        flex: 1,
        minWidth: 16,
        height: 1,
        background: "var(--j-line)"
    }
});
export function CompactionDivider() {
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Divider, null, t("chat.conversation_compacted"));
}
